//为element-ui的Message添加默认参数
import { Toast, Dialog } from 'vant'
import loading from './loading';
import { popComponent, popWin } from './popWin';
import Prompt from './prompt';

Toast.warning = Toast
Toast.error = Toast.fail
Toast.setDefaultOptions({ duration: 4000, forbidClick: false })
Toast.allowMultiple()

function dlg(fn, msg) {
    if (typeof msg === 'string') msg = { message: msg }
    return fn(msg)
}

// 关闭
function closeAll(timer) {
    setTimeout(res => {
        Toast.clear()
    }, timer * 1000)
}

export default {
    msgBox: Dialog,
    toast: Toast,
    loading,
    alert: dlg.bind(0, Dialog.alert),
    confirm: dlg.bind(0, Dialog.confirm),
    close: closeAll,
    prompt(title, placeholder) {
        return new Promise((resolve, reject) => {
            var options = {
                props: {
                    dialogOptions: {
                        title,
                        showCancelButton: true,
                        className: '',
                    },
                    placeholder
                },
                on: {
                    confirm(input) {
                        resolve(input)
                    },
                    cancel(err) {
                        reject(err)
                    }
                }
            }
            popComponent(Prompt, options)
        })
    },
    popWin,
}
